import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import GradiLink from "./gradi-link"
import Socials from "./socials"
import Logo from "../assets/images/gradi-group.svg"


const footerData = () => {
  const {
    allWpMenu: { nodes },
    site: { siteMetadata: { siteLocale } }
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteLocale
          }
        }
        allWpMenu(filter: { name: { eq: "Footer" } }) {
          nodes {
            name
            id
            menuItems {
              nodes {
                id
                url
                path
                label
              }
            }
          }
        }
      }
    `
  )
  return { menu: nodes[0], locale: siteLocale }
}

const Footer = ({ currentBrand }) => {
  let menuURL = ""
  const { menu, locale } = footerData()
  const menuItems = menu?.menuItems?.nodes

  if (
    currentBrand.menu &&
    currentBrand.menu.localFile &&
    currentBrand.menu.localFile.publicURL
  ) {
    menuURL = currentBrand.menu.localFile.publicURL
  }

  const hasStockists =
    currentBrand.brandStyle === "400" ||
    currentBrand.brandStyle === "Zero" ||
    currentBrand.brandStyle == "Mercato"
  const hasEvents =
    currentBrand.brandStyle != "Mercato" && currentBrand.brandStyle != "Pronto"

  const footerItemClass = ""
  const menuLinks = menuItems?.map(item => {
    let linkClass = footerItemClass
    if (item.url === "/location" && currentBrand.defaultLocation) {
      const  { slug } = currentBrand.defaultLocation
      const locationPath = `${currentBrand.path}/location/${slug}`
      return (
        <GradiLink to={locationPath} key={item.label}>
          {item.label}
        </GradiLink>
      )
    }
    if (item.label === "menu" && menuURL !== "") {
      return (
        <GradiLink newWindow to={menuURL} key={item.label}>
          menu
        </GradiLink>
      )
    }

    if (item.label === "events" && !hasEvents) {
      return <></>
    }

    if (item.path === "/wholesale-stockists") {
      if (!hasStockists) {
        return <></>
      }
      linkClass = "text-center"
    }

    return (
      <GradiLink className={linkClass} to={`${currentBrand.path}${item.path}`} key={item.label}>
        {item.label}
      </GradiLink>
    )
  })

  const footerClass =
    "footer lg:h-24 py-10 flex flex-col lg:flex-row align-center items-center justify-between flex-no-wrap uppercase lg:px-24 px-7 gap-10 font-bold"
  return (
    <>

      <div
        className={`bg-blackish text-warm-gray text-sm  mt-16 ${footerClass}`}
      >
      {locale === 'en-us' &&
        menuLinks}
        {locale === 'en-au' && (<>
        <GradiLink to={`${currentBrand.path}/about`}>about</GradiLink>
        { menuURL !== "" ? (
        <GradiLink newWindow to={menuURL}>menu</GradiLink>
        ) : (<></>) }
        <GradiLink to={`${currentBrand.path}/locations`}>locations</GradiLink>
        <GradiLink to={`${currentBrand.path}/contact`}>contact</GradiLink>
        { hasEvents ? (
          <GradiLink to={`${currentBrand.path}/events`}>events</GradiLink>) :
          (<></>)
        }
        <GradiLink to={`${currentBrand.path}/news`}>news</GradiLink>
        { hasStockists ? (
        <GradiLink
          to={`${currentBrand.path}/wholesale-stockists`}
          className="text-center"
        >
          wholesale &amp; stockists
        </GradiLink>
        ) : (<></>) }
        <GradiLink
          to={`${currentBrand.path}/careers/`}
          className={footerItemClass}
        >
          careers
        </GradiLink></>
        )}
      </div>
      <div className={`bg-warm-gray text-xs ${footerClass}`}>
        <div className="flex lg:justify-between align-center items-center gap-10 lg:gap-24 md:flex-row flex-col justify-evenly">
          <div className="logo">
            <GradiLink to={currentBrand.path}>
              <img src={Logo} className="w-36" />
            </GradiLink>
          </div>
          <Socials currentBrand={currentBrand} />
        </div>

        <div className="flex flex-col md:flex-row justify-between align-center items-center gap-6 lg:gap-16 text-center lg:text-left w-full lg:w-min whitespace-nowrap text-tiny md:text-xs">
          <GradiLink
            to={"https://www.studiocalero.com/"}
            className={`${footerItemClass} text-credit hover:text-blackish`}
          >
            Brand & website by Studio Calero
          </GradiLink>
          <GradiLink
            to={`${currentBrand.path}/privacy-policy`}
            className={footerItemClass}
          >
            privacy policy
          </GradiLink>
          <GradiLink
            to={`${currentBrand.path}/terms-and-conditions`}
            className={footerItemClass}
          >
            terms &amp; conditions
          </GradiLink>
        </div>
      </div>
    </>
  )
}

export default Footer
